<template>
  <x-page title="订单管理" :loading="loading">
    <template v-if="!loading">
      <!-- 导航和搜索 -->
      <div :class="_.herder">
        <div :class="[_['pad-both']]">
          <div :class="[_.tabs, _['fontSize-16']]">
            <span
              v-for="(tab, index) in tabs"
              :key="tab"
              v-track="{
                name: tab,
                id: track[index],
              }"
              :class="[activeTabNum == index ? _['active-tab'] : '']"
              @click="changeTab(index)"
              >{{ tab }}</span
            >
          </div>
          <div :class="_['input-search']" class="myinputseach">
            <img :class="_['search-icon']" :src="searchIcom" alt="" />
            <van-field
              ref="inputField"
              v-model="phone"
              clearable
              type="number"
              :maxlength="11"
              :class="_['input-field']"
              placeholder="输入下单手机号搜索订单"
              @focus="keyupField"
              @clear="refuseIndex++"
            />
            <!-- <x-plain-search
              v-model="phone"
              :class="_['input-field']"
              placeholder="输入下单手机号搜索订单"
              @search="seachOrder"
            /> -->
            <div
              v-track="{
                name: '订单管理-搜索',
                id: 'cl9qetghq000skcughx1q4k6z',
              }"
              :class="_['search-btn']"
              @click="seachOrder"
            >
              搜索
            </div>
          </div>
        </div>
      </div>
      <div :class="_['order']">
        <x-waterfall :key="refuseIndex" :load="handleLoad">
          <template #default="{ data }">
            <orderItem
              v-for="(orderInfo, index) in data"
              :key="index"
              :order-state="activeTabNum - 1"
              :order="orderInfo"
              @operation="operation"
            ></orderItem>
          </template>
        </x-waterfall>
        <!-- <template v-if="orderList">
          <orderItem
            v-for="(orderInfo, index) in orderList"
            :key="index"
            :order-state="activeTabNum - 1"
            :order="orderInfo"
          />
        </template> -->
      </div>
    </template>
  </x-page>
</template>

<script>
  import orderItem from './orderItem.vue'
  import searchIcom from './images/搜索.png'
  import Vue from 'vue'
  import { apiOrderMerchantOrderList } from '@/api'
  import { Track } from '@/utils/Track'

  export default Vue.extend({
    components: { orderItem },
    mixins: [
      Track.provideMark(() => ({
        page: '订单管理',
      })),
    ],
    data() {
      return {
        tabs: ['全部', '待接单', '待配送', '配送中', '已完成', '售后/退款'],
        track: [
          'cl9qeyht7000ukcug6yncedxn',
          'cl9qeyq83000wkcugdz8og52w',
          'cl9qeyxlx000ykcug7oyl9vt3',
          'cl9qez5id0010kcuga7xt7j2k',
          'cl9qezbj50012kcug6d2mf04w',
        ],
        activeTabNum: 0,
        searchIcom: searchIcom,
        phone: '',
        orderList: [],
        orderType: 0,
        refuseIndex: 0, //订单请求标识
      }
    },
    computed: {
      loading() {
        return false
      },
      inputDom() {
        return this.$refs.inputField.$el.childNodes[0].childNodes[0]
          .childNodes[0]
      },
    },
    watch: {
      activeTabNum: {
        handler(value) {
          this.switchOrderType(value)
        },
      },
    },
    created() {
      if (this.$route.query.type) {
        this.activeTabNum = this.$route.query.type
      }
      this.switchOrderType(parseInt(this.$route.query.type))
      this.loading = true
    },
    methods: {
      keyupField() {
        this.inputDom.onkeydown = e => {
          if (e.keyCode === 13) this.refuseIndex++
        }
      },
      //订单操作回调
      operation(isRefush, isClose = true) {
        console.log('操作回调', isClose, isRefush)
        if (isRefush) return this.$destroy()
        if (isClose) this.refuseIndex++
      },
      switchOrderType(value) {
        switch (value) {
          case 0:
            this.orderType = 0
            break
          case 1:
            this.orderType = 7
            break
          case 2:
            this.orderType = 8
            break
          case 3:
            this.orderType = 9
            break
          case 4:
            this.orderType = 5
            break
          case 5:
            this.orderType = 11
            break
          default:
        }
        // this.getOrderList(this.orderType)
      },

      changeTab(num) {
        const beforType = this.$route.query.type
        this.$route.query.type = num
        let href = window.location.href
        this.activeTabNum = num
        href = href.replace(`type=${beforType}`, `type=${num}`)
        history.replaceState(null, null, href) // 替换地址栏
        this.refuseIndex++
      },
      //获取订单列表
      async getOrderList(orderType) {
        const result = await apiOrderMerchantOrderList(
          {
            pageIndex: 1,
            pageSize: 10,
            status: orderType,
            userPhone: this.phone,
          },
          { hasStoreCode: true },
        )
        this.orderList = result.list
      },
      //搜索订单
      seachOrder() {
        this.refuseIndex++
        // this.getOrderList(this.orderType)
      },
      handleLoad({ pageNumber }) {
        return apiOrderMerchantOrderList(
          {
            pageIndex: pageNumber,
            pageSize: 10,
            status: this.orderType,
            userPhone: this.phone,
          },
          { hasStoreCode: true },
        )
      },
    },
  })
</script>

<style lang="scss" module>
  .pad-both {
    padding: 0 12px 0 12px;
  }
  .fontSize-16 {
    font-size: 16px;
  }
  .herder {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #fff;
    padding: 12px 0 12px 0;
    z-index: 100;
    .tabs {
      display: flex;
      justify-content: space-between;
      color: #888888;
      .active-tab {
        color: #343434;
        font-weight: 700;
        position: relative;
        &::after {
          display: block;
          position: absolute;
          top: 25px;
          content: '';
          width: 100%;
          height: 2px;
          background-color: #ff202a;
        }
      }
    }
    .input-search {
      height: 34px;
      margin-top: 20px;
      border-radius: 17px;
      border: 1px solid #ff202a;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search-icon {
        width: 20px;
        height: 20px;
        margin-left: 12px;
      }
      .input-field {
        width: 100%;
        height: 24px;
        padding: 0 !important;
      }
      .search-btn {
        width: 60px;
        height: 30px;
        margin-right: 3px;
        margin-left: 20px;
        background: #ffe9ea;
        border-radius: 15px;
        font-size: 14px;
        font-weight: 500;
        color: #ff202a;
        line-height: 30px;
        text-align: center;
      }
    }
  }
  .order {
    width: calc(100% - 24px);
    height: calc(100% - 110px);
    padding: 0 12px 12px 12px;
    position: absolute;
    overflow: scroll;
    top: 101px;
  }
</style>

<style lang="scss">
  .index_input-search_10ED9,
  .myinputseach {
    .van-cell::after {
      border-bottom: none;
    }
  }
</style>
